import React from 'react';

import ApprovalMessage from './ApprovalMessage';
import Message from './Message';
import NavMenu from './navbar/NavMenu';
import Spinner from './Spinner';

import '../../style/layout/Layout.css';

const Layout = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}): JSX.Element => (
  <div>
    <NavMenu />
    {children}
    <Message />
    <ApprovalMessage />
    <Spinner />
  </div>
);

export default Layout;
